(() => {
  const legacySortText = 'Ausgewähltes Format:';
  const panelSelector = '[data-gm-collection-controls]';
  const desktopDisclosureSelector = `${panelSelector} #FacetFiltersForm details.facets__disclosure`;
  let repairQueued = false;

  function removeLegacyFilterControls(root = document) {
    root.querySelectorAll?.('.collection-filter-form, .filter-form').forEach((form) => {
      const text = form.textContent || '';
      if (text.includes(legacySortText) || form.querySelector('select[name="sort_by"]')) {
        form.remove();
      }
    });
  }

  function collectBlocks(root = document) {
    const blocks = [];
    if (root.nodeType === 1 && root.matches?.('.main-collection-product-block')) {
      blocks.push(root);
    }
    root.querySelectorAll?.('.main-collection-product-block').forEach((block) => blocks.push(block));
    return [...new Set(blocks)];
  }

  function groupCollectionControls(root = document) {
    collectBlocks(root).forEach((block) => {
      const section = block.closest('.shopify-section') || block.parentElement;
      if (!section) return;

      let panel = section.querySelector(panelSelector);
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'gm-collection-controls';
        panel.dataset.gmCollectionControls = 'true';
      }

      panel.classList.remove('page-width');

      if (panel.parentNode !== block || panel !== block.firstElementChild) {
        block.insertBefore(panel, block.firstChild);
      }

      const looseSubnav = [...section.querySelectorAll('.sub-colle')].find(
        (element) => !element.closest(panelSelector)
      );
      if (looseSubnav) {
        const existingSubnav = panel.querySelector(':scope > .sub-colle');
        if (existingSubnav && existingSubnav !== looseSubnav) existingSubnav.remove();
        panel.insertBefore(looseSubnav, panel.firstChild);
      }

      const filterElements = [...section.querySelectorAll('#main-collection-filters')];
      const looseFilters = filterElements.find((element) => !element.closest(panelSelector));
      const filters = looseFilters || panel.querySelector(':scope > #main-collection-filters') || filterElements[0];

      if (filters && filters.parentNode !== panel) {
        const existingFilters = panel.querySelector(':scope > #main-collection-filters');
        if (existingFilters && existingFilters !== filters) existingFilters.remove();
        panel.appendChild(filters);
      }

      panel.classList.toggle(
        'gm-collection-controls--without-nav',
        !panel.querySelector(':scope > .sub-colle')
      );
    });
  }

  function repairCollectionGrid(root = document) {
    root.querySelectorAll?.('#product-grid').forEach((grid) => {
      const promo = grid.querySelector(
        '[data-gm-promo-card], .collection-promo-card, .grid-banner, .collection-grid-banner, .promo-card'
      );

      if (!promo || promo.matches('li[data-gm-promo-card]') || promo.closest('li[data-gm-promo-card]')) return;

      const wrapper = document.createElement('li');
      wrapper.className = 'grid__item';
      wrapper.dataset.gmPromoCard = 'true';
      promo.parentNode.insertBefore(wrapper, promo);
      wrapper.appendChild(promo);
    });
  }

  function repairFooterLogo(root = document) {
    root.querySelectorAll?.('footer .footer-block-image').forEach((block) => {
      const image = block.querySelector('img');
      if (!image) return;

      let link = image.closest('a');
      if (!link) {
        link = document.createElement('a');
        link.href = '/';
        image.parentNode.insertBefore(link, image);
        link.appendChild(image);
      } else if (!link.getAttribute('href')) {
        link.href = '/';
      }

      link.setAttribute('aria-label', 'Zur Startseite');
    });
  }

  function setSummaryState(details) {
    const summary = details?.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function syncPanelOpenSpace(panel) {
    const form = panel?.querySelector('#FacetFiltersForm');
    if (!form) return;

    form.style.setProperty('--gm-facet-open-height', '0px');
    form.style.removeProperty('--gm-facet-display-top');

    const openDetails = panel.querySelector('#FacetFiltersForm details.facets__disclosure[open]');
    panel.querySelectorAll('#FacetFiltersForm details.facets__disclosure').forEach(setSummaryState);
    if (!openDetails) return;

    const display = openDetails.querySelector(':scope > .facets__display');
    if (!display) return;

    requestAnimationFrame(() => {
      if (!openDetails.open || !display.isConnected) return;

      const formRect = form.getBoundingClientRect();
      const rowElements = [
        form.querySelector('#FacetsWrapperDesktop'),
        form.querySelector(':scope > .facet-filters'),
        form.querySelector(':scope > .active-facets-desktop')
      ].filter((element) => element && element.offsetParent !== null);

      const baseBottom = Math.max(
        0,
        ...rowElements.map((element) => element.getBoundingClientRect().bottom - formRect.top)
      );
      const displayHeight = display.getBoundingClientRect().height;

      form.style.setProperty('--gm-facet-display-top', `${Math.ceil(baseBottom + 12)}px`);
      form.style.setProperty('--gm-facet-open-height', `${Math.ceil(displayHeight + 24)}px`);
    });
  }

  function syncAllPanels() {
    document.querySelectorAll(panelSelector).forEach(syncPanelOpenSpace);
  }

  function closeDesktopFilters(except = null, restoreFocus = false) {
    let focusTarget = null;

    document.querySelectorAll(desktopDisclosureSelector).forEach((details) => {
      if (details === except || !details.open) return;
      if (restoreFocus && !focusTarget) focusTarget = details.querySelector(':scope > summary');
      details.removeAttribute('open');
      setSummaryState(details);
    });

    syncAllPanels();
    if (focusTarget) focusTarget.focus();
  }

  function runFixes(root = document) {
    removeLegacyFilterControls(root);
    groupCollectionControls(root);
    repairCollectionGrid(root);
    repairFooterLogo(root);
    syncAllPanels();
  }

  function scheduleFixes() {
    if (repairQueued) return;
    repairQueued = true;

    requestAnimationFrame(() => {
      repairQueued = false;
      runFixes(document);
    });
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest(
      `${panelSelector} #FacetFiltersForm details.facets__disclosure > summary.facets__summary`
    );

    if (summary) {
      event.preventDefault();
      event.stopPropagation();

      const details = summary.parentElement;
      const panel = details.closest(panelSelector);
      const shouldOpen = !details.open;

      closeDesktopFilters(details, false);
      details.toggleAttribute('open', shouldOpen);
      setSummaryState(details);
      requestAnimationFrame(() => syncPanelOpenSpace(panel));
      return;
    }

    if (!event.target.closest(`${panelSelector} #FacetFiltersForm .facets__display`)) {
      closeDesktopFilters();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDetails = document.querySelector(`${desktopDisclosureSelector}[open]`);
    if (!openDetails) return;

    const summary = openDetails.querySelector(':scope > summary');
    closeDesktopFilters();
    summary?.focus();
  });

  window.addEventListener('resize', () => {
    requestAnimationFrame(syncAllPanels);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runFixes(document));
  } else {
    runFixes(document);
  }

  document.addEventListener('shopify:section:load', scheduleFixes);
  document.addEventListener('shopify:section:reorder', scheduleFixes);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
      scheduleFixes();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
